import React from 'react';
// Import as ReactComponent so you can render them like <Logo />
import { ReactComponent as DefaultLogo } from '../../assets/branding/default-logo.svg';
import { ReactComponent as DemoHealthcareInstLogo } from '../../assets/branding/demo-healthcare-institute-logo.svg';
import { ReactComponent as GlobalHealthNetworkLogo } from '../../assets/branding/global-health-network-logo.svg';
import { ReactComponent as MedCareInternationalLogo } from '../../assets/branding/medcare-international-logo.svg';

export const BRAND_REGISTRY = {
  'Demo Healthcare Institute': {
    color: '#7b3186bb',
    Icon: DemoHealthcareInstLogo
  },
  'Global Health Network': {
    color: '#db343f',
    Icon: GlobalHealthNetworkLogo
  },
  'MedCare International': {
    color: '#393e36',
    Icon: MedCareInternationalLogo
  },
  'default': {
    color: '#6236e5',
    Icon: DefaultLogo
  }
};